import Vue from "vue";
import Vuex from "vuex";
import ApiUserRepository from "@/repositories/ApiUserRepository";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    loading: {
      display: true,
      message: "Chargement en cours...",
    },
    isAuthenticated: false,
    isAdmin: false,
  },

  mutations: {
    setUser(state, newUser) {
      state.user = newUser;
      if (newUser !== null) {
        state.isAuthenticated = true;

        // pour chaque rôle de l'utilisateur,
        var roles = ["GRH", "Admin", "Superadmin"];
        state.isAdmin = false;
        // on teste sa présence dans la liste des rôles autorisés à accéder à cette route
        if (Array.isArray(roles)) {
          state.isAdmin = false;
          if (Array.isArray(state.user.roles)) {
            state.user.roles.forEach((userRole) => {
              if (roles.indexOf(userRole) > -1) {
                state.isAdmin = true;
              }
            });
          }
        }
      }
    },

    setEcranChargement(state, display) {
      state.loading.display = display;
    },

    setMessageEcranChargement(state, message) {
      state.loading.message = message;
    },
  },

  actions: {
    async loadUser({ commit }) {
      let newUser = await ApiUserRepository.getUser();
      if (Object.keys(newUser).length === 0) {
        newUser = null;
      }
      commit("setUser", newUser);
    },
    async switchUser({ commit }, idUser) {
      const user = await ApiUserRepository.switchUser(idUser);
      commit("setUser", user);
    },
    async unswitchUser({ commit }) {
      const user = await ApiUserRepository.unswitchUser();
      commit("setUser", user);
    },
  },
});
